const PRODUCTION = {
  SUPER_ADMIN_ID: 8,
  url: {
    API_URL: 'https://api-tag.apdigital.net',
    AP_API_URL: 'https://mw.apthai.com/social-tag',
  },
  AP_API_KEY: 'PeW2yECg9o9ALwbyv8XfZacBYOaEDeH5',
};


const UAT = {
  SUPER_ADMIN_ID: 1,
  url: {
    API_URL: 'https://uat-api-tag.apdigital.net',
    AP_API_URL: 'https://mw-dev.apdigital.net/social-tag',
  },
  AP_API_KEY: 'AIzaSyBBogi9rwrBCyV4iB9mxW6RHXayeQPj2Ks',
};

console.log('REACT_APP_ENVIRONMENT', process.env.REACT_APP_ENVIRONMENT);

export const Config =
  process.env.REACT_APP_ENVIRONMENT === 'uat' ? UAT : PRODUCTION;
